import { VIEW } from '@v4/store/builderStore/models/Preview.model'
import BaseSelector, { hookFromSelector, withStaticSelector } from './BaseSelector'

class PreviewSelector extends BaseSelector {
	static fromStoreState(store) {
		return new this(store.builder.preview)
	}

	/**
	 * @class PreviewSelector
	 * @property {function(storeState: Object): string|number} selectSortingSectionId
	 * @property {function(): string|number} useSortingSectionId
	 */
	@hookFromSelector('useSortingSectionId')
	@withStaticSelector
	selectSortingSectionId() {
		return this.state.sortingSectionId
	}

	/**
	 * @class PreviewSelector
	 * @property {function(storeState: Object): boolean} selectSorting
	 * @property {function(): boolean} useSorting
	 */
	@hookFromSelector('useSorting')
	@withStaticSelector
	selectSorting() {
		return !!this.selectSortingSectionId()
	}

	/**
	 * @class PreviewSelector
	 * @property {function(storeState: Object): string} selectMode
	 * @property {function(): string} useMode
	 */
	@hookFromSelector('useMode')
	@withStaticSelector
	selectMode() {
		return this.state.mode
	}

	/**
	 * @class PreviewSelector
	 * @property {function(storeState: Object): boolean} selectIsMobileView
	 * @property {function(): boolean} useIsMobileView
	 */
	@hookFromSelector('useIsMobileView')
	@withStaticSelector
	selectIsMobileView() {
		return this.selectMode() === VIEW.MOBILE
	}
}

export default PreviewSelector
